import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'removeLeadingZeros'
})
export class RemoveLeadingZerosPipe implements PipeTransform {
  transform(value: string): string {
    return String(parseInt(value, 10));
  }
}